import type { IconPropsWithoutName } from '../index'

// biome-ignore lint/plugin: RETIRED, do not copy. Convert to a named function export when touching this.
export const CircleAlertFilled: React.FC<IconPropsWithoutName> = ({ color = 'currentColor', className, ...props }) => {
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: decorative icon; the Icon wrapper carries the accessible name
    <svg viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
      <path
        d="M7.00016 14.1663C3.31826 14.1663 0.333496 11.1815 0.333496 7.49967C0.333496 3.81777 3.31826 0.833008 7.00016 0.833008C10.682 0.833008 13.6668 3.81777 13.6668 7.49967C13.6668 11.1815 10.682 14.1663 7.00016 14.1663ZM6.3335 9.49967V10.833H7.66683V9.49967H6.3335ZM6.3335 4.16634V8.16634H7.66683V4.16634H6.3335Z"
        fill={color}
      />
    </svg>
  )
}
